import { apiBaseUrl, errorHandler as eh } from '@/main'

/**
 * Includes helpers for headers and checkResponse method
 * these are imported in each domain api
 */

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
}

const validStatuses = [200, 201, 202, 203, 204, 300, 301, 302, 303, 304]

/**
 * Get header wrapper
 */
export function getHeader () {
  const defaultHeaders = DEFAULT_HEADERS

  return defaultHeaders
}

/**
 * Url-formatter
 */
export function getUrl (endPoint) {
  const url = apiBaseUrl + endPoint
  return url
}

/**
 * query-string parameter formatter
 */

/**
 * Check response for validity
 * return promise.reject if error
 */
export function checkResponse (response) {
  if (validStatuses.includes(response.status)) {
    return response.data
  }

  if (response.status === 401) {
    // eslint-disable-next-line
    console.log(
      '[ERROR] User is not authorized, initializing security measures...'
    )
    return Promise.reject(new Error('USER_UNAUTHORIZED'))
  }

  const err = new Error(response.statusText)
  err.response = response

  return Promise.reject(err)
}

export function errorHandler (message) {
  eh(message)
}
